import { render } from "./TimeComponent.vue?vue&type=template&id=6e52c07c"
import script from "./TimeComponent.vue?vue&type=script&lang=js"
export * from "./TimeComponent.vue?vue&type=script&lang=js"

import "./TimeComponent.vue?vue&type=style&index=0&id=6e52c07c&scopped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__